import {Component} from '@angular/core';

@Component({
    selector: 'app-error-404',
    styleUrls: ['404.sass'],
    templateUrl: '404.tpl.html'
})
export class Error404ViewComponent {
}
